import axios from 'axios';

// Update base URL handling
export const getBaseUrl = (): string => {
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';
};

export const getApiBaseUrl = (): string => {
  return `${getBaseUrl()}/api`;
};

export const getAssetBaseUrl = (): string => {
  return getBaseUrl();
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }
  return config;
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (name: string, password: string) => api.post('/auth/login', { name, password }).then(r => r.data),
  register: (name: string, email: string, password: string) => api.post('/auth/register', { name, email, password }).then(r => r.data),
  requestRegisterOtp: (name: string, email: string, password: string) => api.post('/auth/register/request-otp', { name, email, password }).then(r => r.data),
  verifyRegisterOtp: (email: string, otp: string) => api.post('/auth/register/verify-otp', { email, otp }).then(r => r.data),
};

export const configAPI = {
  getLandingConfig: () => api.get('/config'), // backend also supports /config/landing
  getByKey: (key: string) => api.get(`/config/${encodeURIComponent(key)}`),
};

export const teamAPI = {
  getTeamMembers: async () => {
    try {
      const r = await api.get('/config/team_members');
      const value = r.data?.data?.value ?? r.data?.value ?? r.data?.data;
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      return { data: { data: parsed || [] } };
    } catch (_) {
      const all = await configAPI.getLandingConfig();
      const cfg = all.data?.data ?? all.data;
      const teamValue = Array.isArray(cfg) ? cfg.find((c: any) => c.key === 'team_members')?.value : cfg?.team_members ?? cfg['team_members'];
      let parsed: any[] = [];
      try {
        parsed = typeof teamValue === 'string' ? JSON.parse(teamValue) : teamValue || [];
      } catch {
        parsed = [];
      }
      return { data: { data: parsed } };
    }
  },
};

// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     const requestUrl = error.config?.url;
//     // Skip logout + redirect when: login or register APIs fail
//     const isAuthRoute =
//       requestUrl?.includes('/login') || requestUrl?.includes('/register');

//     if (!isAuthRoute && error.response?.status === 401) {
//       // This should run only for protected routes, not login/register
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }

//     return Promise.reject(error);
//   }
// );

export default api;
